<!-- <div class="d-flex align-items-center h-100"> -->
    <div class="live-class-content text-center">
        <img class="icon" src="assets/img/live-class-icon.svg" alt="">
        <p>Live classes will be launching soon with India's top educators. We'll keep you posted</p>
        <!-- <button routerLink="/dashboard" type="button" class="btn btn-outline-secondary">Back to neet preparation</button> -->
    </div>
<!-- </div> -->